










































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
// import { ScanRulesVuex, StoreVuex } from "@root/utiles/constant";
import { handlePaginationDecorator } from "@root/lib/decorator";
import { clearEmptyAttr, showConfirmDialog } from "@root/utiles/common";
import CustomSelect from "@/components/custom/CustomSelect.vue";
import ExportSelectDialog from "./ExportSelectDialog.vue";
import CreditLimitAjustDialog from "./creditLimitAjustDialog.vue";
import CreditDebtAjustDialog from "./creditDebtAjustDialog.vue";
import InitPassWordDialog from "./initPassWordDialog.vue";
import AuthPwdDialog from "./authPwdDialog.vue";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";

const root = namespace("root");
const common = namespace("common");
const scan = namespace("scan");
const storeManage = namespace("storeManage");
const credit = namespace("credit");
@Component({
  components: {
    CustomSelect,
    ExportSelectDialog,
    CreditLimitAjustDialog,
    CreditDebtAjustDialog,
    InitPassWordDialog,
    AuthPwdDialog
  }
})
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class WtStoreManagement extends Vue {
  @root.State ddCodes;
  @common.Action queryDataDictionaryListLang;
  @storeManage.Action getScanSystemData: Function;
  @scan.Action queryCustomerLevelList;
  @storeManage.Action exportK1StoreManagement: Function;
  @storeManage.Action getK1CustomerManagePageRest: Function;
  @storeManage.Action updateK1CustomerRemaker: Function;
  @storeManage.Action updateStoreCustomerLevel: Function;
  @storeManage.Action exportGitiCustomStoreRest: Function;
  @common.Action queryShopInfo;
  @credit.Action validFinancialSecurityPwd;
  @credit.Action updateCreditLimit;
  @credit.Action updateCreditDebt;
  @common.Action getDataValue;

  private dataList = [];
  private storeLevelOptions = [];
  private wtStoreTypeData = [];
  private wtStoreStarTypeData = [];
  gtExportDialog = false;
  exportParams = {};
  private dialogVisible = false;
  private OPBooleanMap: {
    1: "是";
    0: "否";
  };
  tabListOptions: any[] = [
    { value: "", label: "全部" },
    { value: 0, label: "启用" },
    { value: 1, label: "禁用" }
  ];
  // 搜索参数
  private form: any = {
    storeCode: "", // 门店多条件查询字段
    state: "", // 状态
    storeTagCode: "", // 门店类型
    storeStarGrade: "", // 星级
    levelCode: "", // 级别
    isK2AppM: "" // 是否二批
  };
  private K2AppMList = [
    // 是否是二批商
    {
      label: "是",
      value: 1
    },
    {
      label: "否",
      value: 0
    }
  ];
  private isMemoVisible = false;
  private currentRow = null;

  private editForm = {
    memo: ""
  };

  limitDialogVisible: any = false;
  debtDialogVisible: any = false;
  pwdDialogVisible: any = false;
  AuthPwdDialogVisible: any = false;

  get dataListComputeds() {
    this.dataList.forEach(el => {
      this.$set(el, "levelCode", (el && el.levelCode) || "");
    });
    return this.dataList;
  }
  async getSystemTagsApi() {
    let list = await this.queryCustomerLevelList();
    list = list.map(v => ({ label: v.levelName, value: v.levelCode }));
    this.storeLevelOptions = list || [];
  }
  isOaCooperation: any = "";
  memberType: any = "";
  marketType: any = "";
  showFinanceInfo: any = false;
  async created() {
    this.memberType = localStorage.getItem("memberType");
    this.marketType = localStorage.getItem("marketType");

    this.isOaCooperation = localStorage.getItem("isOaCooperation");
    await this.getSystemTagsApi();
  }
  async mounted() {
    await this.getTypeData();
    this.getData();
    this.getScanSystemData();
    this.getDic();
  }

  async getDic() {
    let res = await this.getDataValue({
      dataCode: "CREDIT_SWITCH"
    });
    if (
      res.dataValue === "1" &&
      this.memberType === "11" &&
      this.marketType === "PCR"
    ) {
      this.showFinanceInfo = true;
    }
    console.log(res, "-----CREDIT_SWITCH");
  }

  // 列表请求参数
  get getParams() {
    return {
      input: clearEmptyAttr(this.form)
    };
  }

  async handleDialogMemo() {
    const {
      accountNum,
      storeCode,
      storeName,
      district,
      state,
      storeTagName,
      storeTagCode,
      categoryCode,
      branch,
      storeStarGrade
    } = this.currentRow as any;
    console.log(this.currentRow, "当前行信息");
    try {
      const res = await this.updateK1CustomerRemaker({
        input: {
          storeInfo: accountNum,
          storeCode,
          storeName,
          district,
          state,
          storeTagName,
          storeTagCode,
          categoryCode,
          branch,
          starName:
            this.formatStar(storeStarGrade) == "-"
              ? ""
              : this.formatStar(storeStarGrade),
          starGrade: storeStarGrade,
          remarkName: this.editForm.memo || ""
        }
      });
      if (res) {
        this.isMemoVisible = false;
        this.$message.success("修改成功！");
        this.getData();
      }
    } catch (error) {
      console.log(error);
    }
    console.log("rwo");
  }

  // @handlePaginationDecorator({
  //   listField: "dataList",
  //   fnName: "getK1CustomerManagePage",
  //   fnParams: "getParams"
  // })
  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    try {
      let res = await this.getK1CustomerManagePageRest({
        pageSize,
        pageNum,
        ...this.form
      });
      this.dataList = res.list || [];
      (this as any).total = res.total || 0;
    } catch (e) {
      console.log(e);
    }
  }
  async getTypeData() {
    this.wtStoreTypeData = await this.queryDataDictionaryListLang({
      statePath: "wtStoreTypeData",
      ddCode: "WT_STORE_TYPE"
    });
    this.wtStoreStarTypeData = await this.queryDataDictionaryListLang({
      statePath: "wtStoreStarTypeData",
      ddCode: "WT_STAR_TYPE"
    });
  }

  handleRowCancel(rowIdx?: string) {
    // console.log(this.$refs[`tagPicker${rowIdx}`]);
    // console.log(this.$refs, rowIdx, this.$refs[`tagPicker${rowIdx}`], "---");
    // try {
    //   (this.$refs[`tagPicker${rowIdx}`] as any).doClose();
    //   (this.$refs[`tagPicker${rowIdx}`] as any).showPopper = false;
    // } catch (error) {
    //   // console.log(error);
    // }
    document.body.click();
  }
  async handleRowConfirm(row, rowIdx) {
    try {
      const { storeCode, levelCode, storeName } = row;
      if (!levelCode) {
        this.$message.error("请选择级别");
        return;
      }
      const res = await this.updateStoreCustomerLevel({
        storeLevelInput: {
          storeCode,
          storeName,
          levelCode
        }
      });
      this.handleRowCancel();
      this.$message.success("设置成功");
      this.getData();
    } catch (error) {
      console.log(error);
    }
  }

  tabToggleHandle(tab) {
    this.form.state = tab ? +tab : "";
    this.getData();
  }
  handleRow(row) {
    this.isMemoVisible = true;
    this.currentRow = row;
    const { remarkName } = row;
    this.editForm = {
      memo: remarkName
    };
  }

  toDetail(row: any) {
    this.$router.push({
      name: "storeMgDetail",
      query: { code: row.storeCode }
    });
  }
  submitOptions(options) {
    console.log(options, "获取的配置项");
    if (options && options.length > 0) {
      this.exportParams = {
        ...clearEmptyAttr(this.form),
        exportFields: options
      };
      console.log(this.exportParams, "导出的参数");
      this.gtExportDialog = true;
    }
  }
  formatStar(val) {
    const obj = this.wtStoreStarTypeData.find(o => o.value == val);
    return obj && obj.label ? obj.label : "-";
  }

  curEditRow: any = {};
  editType: any = ""; // 01: 信用金额度， 02: 欠款
  // 调整信用金额度
  async adjustCreditLimitFn(row) {
    // 1.是否在已输入密码的10分钟内，A:是 | B:否
    //  A.打开 调整信用金额度弹窗
    //  B.是否已设置初始资金管理密码，B-1：是 | B-2: 否
    //    B-1.打开 授权密码验证弹窗，验证成功之后打开 调整信用金额度弹窗
    //    B-2.打开 资金管理密码维护弹窗，验证成功后（需要和产品确认时直接打开调整信用金额度弹窗还是让他重新点击调整按钮验证)
    // this.AuthPwdDialogVisible = true;
    this.editType = "01";
    this.curEditRow = row;
    let { list } = await this.queryShopInfo({
      shopCode: localStorage.getItem("memberCode") || "",
      pageInput: {
        pageSize: 10,
        pageNum: 1
      }
    });
    let isSetPwd: any = list[0] && list[0].financialPwd;
    // let isSetPwd = false;
    console.log(isSetPwd, "--queryShopInfo");
    if (isSetPwd) {
      // 已经设置过初始密码,
      let res = await this.validFinancialSecurityPwd({
        shopCode: localStorage.getItem("memberCode") || "",
        marketType: localStorage.getItem("marketType") || ""
      });
      console.log(res, "---validFinancialSecurityPwd");
      if (res) {
        // 已经输入密码的10分钟内
        this.limitDialogVisible = true;
      } else {
        // 没有在10分钟内输入过密码，需要验证密码
        this.AuthPwdDialogVisible = true;
      }
      // this.AuthPwdDialogVisible = true;
    } else {
      // 未设置初始密码
      this.pwdDialogVisible = true;
    }
  }
  // 调整门店欠款
  async adjustCreditDebtFn(row) {
    // 1.是否在已输入密码的10分钟内，A:是 | B:否
    //  A.打开 信用金回款弹窗
    //  B.是否已设置初始资金管理密码，B-1：是 | B-2: 否
    //    B-1.打开 授权密码验证弹窗，验证成功之后打开 信用金回款弹窗
    //    B-2.打开 资金管理密码维护弹窗，验证成功后（需要和产品确认时直接打开信用金回款弹窗还是让他重新点击调整按钮验证)
    // this.pwdDialogVisible = true;
    this.curEditRow = row;
    this.editType = "02";
    let { list } = await this.queryShopInfo({
      shopCode: localStorage.getItem("memberCode") || "",
      pageInput: {
        pageSize: 10,
        pageNum: 1
      }
    });
    let isSetPwd: any = list[0] && list[0].financialPwd;
    // let isSetPwd = false;
    console.log(isSetPwd, "--queryShopInfo");
    if (isSetPwd) {
      // 已经设置过初始密码,
      let res = await this.validFinancialSecurityPwd({
        shopCode: localStorage.getItem("memberCode") || "",
        marketType: localStorage.getItem("marketType") || ""
      });
      console.log(res, "---validFinancialSecurityPwd111111");
      if (res) {
        // 已经输入密码的10分钟内
        this.debtDialogVisible = true;
      } else {
        // 没有在10分钟内输入过密码，需要验证密码
        this.AuthPwdDialogVisible = true;
      }
      // this.AuthPwdDialogVisible = true;
    } else {
      // 未设置初始密码
      this.pwdDialogVisible = true;
    }
  }
  // 确定修改信用金额度
  async submitLimitFn(val) {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    await this.updateCreditLimit({
      storeCode: this.curEditRow.storeCode,
      tenantCode: userInfo.tenantCode,
      oldCreditLimit: this.curEditRow.creditLimit,
      newCreditLimit: val //这个是输入框中的值
    });
    this.$message.success("调整成功");
    this.limitDialogVisible = false;
    this.getData();
    console.log(val, "-submitLimitFn");
  }
  // 确定修改信用金回款
  async submitDebtFn(val) {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    await this.updateCreditDebt({
      storeCode: this.curEditRow.storeCode,
      tenantCode: userInfo.tenantCode,
      oldCreditDebt: this.curEditRow.creditDebt,
      turnaroundAmount: val //这个是输入框中的值
    });
    this.$message.success("调整成功");
    this.debtDialogVisible = false;
    this.getData();
    console.log(val, "-submitDebtFn");
  }
  // 确定修改密码
  submitPwdFn(val) {
    console.log(val, "-submitPwdFn");
  }
  // 确定授权密码
  async submitAuthPwdFn(val) {
    let res = await this.validFinancialSecurityPwd({
      shopCode: localStorage.getItem("memberCode"),
      marketType: localStorage.getItem("marketType"), //必填
      financialPwd: val //必填
      // timeOut: 120000
    });
    if (res) {
      this.AuthPwdDialogVisible = false; //关闭授权密码输入弹窗
      console.log(this.editType, "---this.editType");
      if (this.editType === "01") {
        this.limitDialogVisible = true; //打开调整额度弹窗
      }
      if (this.editType === "02") {
        this.debtDialogVisible = true; //打开调整额度弹窗
      }
    } else {
      this.$message.error("密码错误，请重新输入");
    }
    console.log(val, "-submitAuthPwdFn");
  }
}
